"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

/* eslint-disable promise/avoid-new */
var ZipWrapper = /*#__PURE__*/function () {
  function ZipWrapper() {
    (0, _classCallCheck2["default"])(this, ZipWrapper);
  }

  (0, _createClass2["default"])(ZipWrapper, null, [{
    key: "unzip",
    value: function () {
      var _unzip = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(filename, outputDirectory, progressCallback) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new _promise["default"](function (resolve, reject) {
                  var callback = function callback(returnValue) {
                    if (returnValue < 0) {
                      reject(new Error("error unzipping file ".concat(filename, " -- code ").concat(returnValue)));
                      return;
                    }

                    resolve();
                  };

                  var onProgress = function onProgress(progressObj) {
                    progressObj.isUnzipping = true;

                    if (progressCallback) {
                      progressCallback(progressObj);
                    }
                  };

                  window.zip.unzip(filename, outputDirectory, callback, onProgress);
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function unzip(_x, _x2, _x3) {
        return _unzip.apply(this, arguments);
      }

      return unzip;
    }()
  }]);
  return ZipWrapper;
}();

var _default = ZipWrapper;
exports["default"] = _default;